import {Pagination} from "../pagination.interface";

interface AuditLogInterface {
    id: number;
    created: string;
    userId: number;
    companyId: number;
    event: string;
    metadata: any;
}

class AuditLog implements AuditLogInterface {
    static readonly EVENT_MESSAGE_CREATED     = 'MESSAGE_CREATED';
    static readonly EVENT_MESSAGE_MODIFIED    = 'MESSAGE_MODIFIED';
    static readonly EVENT_MESSAGE_DELETED     = 'MESSAGE_DELETED';
    static readonly EVENT_MESSAGE_APPROVED    = 'MESSAGE_APPROVED';
    static readonly EVENT_MESSAGE_DISAPPROVED = 'MESSAGE_DISAPPROVED';

    companyId: number;
    created: string;
    event: string;
    id: number;
    metadata: any;
    userId: number;
}

class AuditLogResponse {
    result: AuditLogInterface[];
    pagination: Pagination;
}

export {
    AuditLogInterface,
    AuditLog,
    AuditLogResponse
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/audits/api.models.ts